import SvgIcon from "@mui/material/SvgIcon";

export const StandardAdminsIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill="#fff"
        d="M22.25 20.5H1.75a1.5 1.5 0 110-3h20.5a1.5 1.5 0 110 3zm-20.5-2a.5.5 0 000 1h20.5a.5.5 0 000-1H1.75zM21.5 17h-1V5a.5.5 0 00-.5-.5H4a.5.5 0 00-.5.5v12h-1V5A1.5 1.5 0 014 3.5h16A1.5 1.5 0 0121.5 5v12z"></path>
      <g fill="#fff" clipPath="url(#clip0_32394_12756)">
        <path d="M12.002 12.75a2 2 0 110-4 2 2 0 010 4zm0-3.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM15.498 9.251a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-2.5a1 1 0 100 2 1 1 0 000-2zM17.75 11.75H15v-.5h2.5v-.5a1.472 1.472 0 00-.44-1.057l-.178-.175.334-.371.188.184A1.973 1.973 0 0118 10.75v.75a.25.25 0 01-.25.25zM8.502 9.251a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-2.5a1 1 0 100 2 1 1 0 000-2zM9 11.75H6.25A.25.25 0 016 11.5v-.75a1.958 1.958 0 01.608-1.431l.18-.173.346.362-.181.173A1.461 1.461 0 006.5 10.75v.5H9v.5z"></path>
        <path d="M15.252 16.25h-6.5a.25.25 0 01-.25-.25v-.25a3.48 3.48 0 011.637-2.962l.212-.133.266.424-.212.133a2.981 2.981 0 00-1.403 2.538h6a3.002 3.002 0 00-.878-2.125 2.854 2.854 0 00-.522-.412l-.214-.13.26-.428.214.13c.224.138.43.301.617.487a3.5 3.5 0 011.023 2.478V16a.25.25 0 01-.25.25z"></path>
      </g>
      <defs>
        <clipPath id="clip0_32394_12756">
          <path fill="#fff" d="M0 0H12V12H0z" transform="translate(6 5)"></path>
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);
